import { Component, Input, OnInit } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { StationService } from "src/app/_services/station.service";
import { UserInfoService } from "src/app/_services/userInfo.service";
import { MenuRouteID } from "src/app/components/header/menu-item/nav-item";
import { Permission } from "src/app/util/enums/permission.enum";

@Component({
  selector: 'telio-device-photos',
  templateUrl: './device-photos.component.html',
  styleUrls: ['./device-photos.component.scss']
})
export class DevicePhotosComponent implements OnInit {
  @Input() stationdetail: any;
  @Input() stationId: any;
  photosList = [];
  @Input() routeID = null;

  constructor(readonly router: Router, private stationService: StationService, readonly userInfoService: UserInfoService) { }

  ngOnInit(): void {
    if (this.stationdetail && this.stationdetail.amenitiesUrl)
      this.LoadPhotos();
    else
      this.getstationlistbyid(this.stationId);
  }

  LoadPhotos() {
    this.photosList = this.stationdetail.amenitiesUrl.replace(' ', '').split('#');
  }

  getstationlistbyid(id) {
    this.stationService.getstationlistbyid(id).subscribe(
      (data: any) => {
        this.stationdetail = data;
        if (this.stationdetail && this.stationdetail.amenitiesUrl)
          this.LoadPhotos();
      },
      error => {
      }
    );
  }

  editPhotos() {
    let objToSend: NavigationExtras = {
      queryParams: {
        "routedName": 'devicePhotos',
        "stationId": this.stationId,
      },
      skipLocationChange: false
    };

    this.router.navigate(["/dashboard/add-station", { routeID: MenuRouteID.STATIONS }], objToSend);
  }

  checkPermission(): boolean {
    return this.userInfoService.filterPermission(this.routeID, Permission.UPDATE)
  }

}